import { ZERO_INCHES } from "building-types/plans/constants";
import type { SheetInches } from "common/types/nominalNumbersTypes";
import { sheetInchesNew } from "common/utils/nominalNumbers";

export enum LevelAnnotationMethod {
  FIXED = "FIXED",
  ELEVATION_RELATIVE = "ELEVATION_RELATIVE",
}

export enum ElevationNoteEntityDebugMode {
  NONE = "NONE",
  ALL = "ALL",
  TAGGED = "TAGGED",
  TAGGED_PLUS_BOX = "TAGGED_PLUS_BOX",
}

export interface ElevationDebugOptions {
  readonly debugElevationColliders: boolean;
  readonly showElevationNoteEntities: ElevationNoteEntityDebugMode;
}

export type ElevationAnnotationParams = {
  readonly levelAnnotationMethod?: LevelAnnotationMethod;
  readonly levelAnnotationOffset?: SheetInches;
  readonly levelAnnotationVerticalSpacing?: SheetInches;
  readonly boundingBoxElbowXSpacing?: SheetInches;
  readonly boundingBoxLabelXSpacing?: SheetInches;
  readonly labelTextWidth?: SheetInches;
};

export const defaultElevationAnnotationParams: Required<ElevationAnnotationParams> = {
  levelAnnotationMethod: LevelAnnotationMethod.FIXED,
  levelAnnotationOffset: ZERO_INCHES,
  levelAnnotationVerticalSpacing: sheetInchesNew(0.5),
  boundingBoxElbowXSpacing: sheetInchesNew(1),
  boundingBoxLabelXSpacing: sheetInchesNew(1),
  labelTextWidth: sheetInchesNew(1),
};
